import {
  NavLink,
  ProcessStep,
  Feature,
  PricingPlan,
  FAQItem,
} from "../types/landing";

export const NAVIGATION_LINKS: NavLink[] = [
  { label: "Pricing", href: "#pricing" },
  { label: "How it works", href: "#process" },
  { label: "Features", href: "#features" },
];

export const PROCESS_STEPS: ProcessStep[] = [
  {
    id: "step-01",
    number: "01",
    title: "Discover Your Business",
    description:
      "We start by understanding your vision, goals, audience, competitors, and market through a guided discovery process that creates the foundation for every decision.",
  },
  {
    id: "step-02",
    number: "02",
    title: "Receive your brand package",
    description:
      "Brand identity, strategy documents, and campaign plans — delivered to your mailbox.",
  },
  {
    id: "step-03",
    number: "03",
    title: "Receive your brand package",
    description:
      "Brand identity, strategy documents, and campaign plans — delivered to your mailbox.",
  },
  {
    id: "step-04",
    number: "04",
    title: "Receive your brand package",
    description:
      "Brand identity, strategy documents, and campaign plans — delivered to your mailbox.",
  },
];

export const FEATURES: Feature[] = [
  {
    id: "feature-01",
    number: "01",
    title: "01 \n Research Brief",
    description:
      "AI researches your market, audience, competitors, trends, and positioning opportunities before generating any branding recommendations.",
  },
  {
    id: "feature-02",
    number: "02",
    title: "02 \n Human Approval",
    description:
      "Review, edit, and approve every stage of the process. You stay in control while AI accelerates the work.",
  },
  {
    id: "feature-03",
    number: "03",
    title: "03 \n Brand Identity",
    description:
      "Generate your brand name, personality, mission, vision, tone of voice, colors, typography, and visual direction.",
  },
  {
    id: "feature-04",
    number: "04",
    title: "04 \n Brand Strategy",
    description:
      "Receive positioning, messaging frameworks, audience insights, communication strategy, and growth recommendations tailored to your market.",
  },
  {
    id: "feature-05",
    number: "05",
    title: "05 \n Campaign Content",
    description:
      "Create blogs, social media posts, ads, emails, website copy, product descriptions, and marketing campaigns that match your brand.",
  },
  {
    id: "feature-06",
    number: "06",
    title: "06 \n Brand Workspace",
    description:
      "Manage assets, collaborate with your team, organize campaigns, monitor performance, and continue growing your brand from a single workspace.",
  },
];

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: "starter",
    name: "STARTER",
    monthlyPrice: "₹ 599",
    monthlyPeriod: "/per month",
    annualPrice: "₹",
    annualPeriod: "/per year",
    description: "",
    features: [
      "Unlimited workspaces",
      "Full Brand Identity(7 Sections)",
      "Complete Brand Strategy",
      "Exports in PDF / DOCS",
      "All Campaign Types",
      "Priority generation",
    ],
    ctaText: "Subscribe",
  },
  {
    id: "professional",
    name: "PROFESSIONAL",
    monthlyPrice: "₹ 1,999",
    monthlyPeriod: "/per month",
    annualPrice: "₹ ",
    annualPeriod: "/per year",
    description: "",
    isPopular: true,
    features: [
      "Unlimited workspaces",
      "Full Brand Identity(7 Sections)",
      "Complete Brand Strategy",
      "Exports in PDF / DOCS",
      "All Campaign Types",
      "Priority generation",
    ],
    ctaText: "Subscribe",
  },
  {
    id: "enterprise",
    name: "ENTERPRISE",
    description: "",
    monthlyPrice: "₹ 3,999",
    monthlyPeriod: "/per month",
    annualPrice: "₹ ",
    annualPeriod: "/per year",
    features: [
      "Unlimited workspaces",
      "Full Brand Identity(7 Sections)",
      "Complete Brand Strategy",
      "Exports in PDF / DOCS",
      "All Campaign Types",
      "Priority generation",
    ],
    ctaText: "Subscribe",
  },
];

export const FAQ_ITEMS: FAQItem[] = [
  {
    id: "faq-01",
    question: "How is AIGIO different from other AI tools?",
    answer:
      "AIGIO doesn't simply answer prompts. It understands your business, researches your market, builds your brand strategy, generates your identity, and creates content within one connected workflow.",
  },
  {
    id: "faq-02",
    question: "How long does the branding process take?",
    answer:
      "Most businesses complete research, brand strategy, and identity within an hour. Content generation continues instantly whenever you need it.",
  },
  {
    id: "faq-03",
    question: "Can I review AI recommendations before using them?",
    answer:
      "Yes. Every stage—from research to strategy and brand identity—is reviewed and approved by you before moving forward.",
  },
  {
    id: "faq-04",
    question: "Who is AIGIO built for?",
    answer:
      "Founders, startups, agencies, consultants, D2C brands, and growing businesses that want a professional branding process without hiring a full branding agency.",
  },
  {
    id: "faq-05",
    question: "Is the Website Audit included in my subscription?",
    answer:
      "Website and Social Media Audits can be purchased individually and generate a professional report in minutes. Subscribers also receive platform credits for ongoing AI workflows.",
  },
  {
    id: "faq-06",
    question: "Can my team collaborate?",
    answer:
      "Yes. Depending on your plan, you can invite team members, manage approvals, organize assets, and work together from a shared workspace.",
  }
];

export const HERO_TEXT = {
  headline: "Your brand, engineered by HxAI.",
  subheadline: "AI",
  description:
    "AIGIO researches your market, builds your strategy, creates your brand identity, and prepares the launch-ready campaigns—all in one guided workflow.",
  ctaPrimary: "Website Audit",
  ctaSecondary: "Social Media Audit",
};

export const METRICS = [
  { label: "Questionnaire", value: "Business Discovery" },
  { label: "AI Review", value: "Approve Every Step" },
  { label: "Launch Ready", value: "Complete Brand Package" },
];

export const AUDIT_CTA = {
  title: "Know exactly what's holding your brand back.",
  description:
    "Get an AI-powered analysis of your website or social presence with actionable recommendations covering branding, SEO, user experience, content, positioning, and conversion opportunities.Delivered in minutes.",
  placeholder: "Enter website URL",
  buttonText: "Website Audit",
  secondaryButtonText: "Social Media Audit",
};
